import { render, staticRenderFns } from "./OrderCalendarPage.vue?vue&type=template&id=1a188e16&scoped=true&"
import script from "./OrderCalendarPage.vue?vue&type=script&lang=js&"
export * from "./OrderCalendarPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderCalendarPage.vue?vue&type=style&index=0&id=1a188e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a188e16",
  null
  
)

export default component.exports